import React from 'react';
import { ActionBase } from '../ActionBase';
import { Store } from '../Store';
import { copyObject } from 'common/copyObject';
import { callGetServiceProhibitionApi, GetServiceProhibitionResData } from 'requests/RequestUser';
import { HttpStatus } from 'consts/HttpStatus';

export type ServiceProhibitionData = { use_prohibited_service: boolean };

export const initialServiceProhibitionData: ServiceProhibitionData = {
	use_prohibited_service: false,
};

//////////////////////////////////////////////////
// SaveAction
//////////////////////////////////////////////////
// Action
class SaveAction extends ActionBase {
	serviceProhibitionData: ServiceProhibitionData;
}
// Action name
const SaveActionName = SaveAction.toString();

// Action generator
export const saveGenerator = async (dispatch: React.Dispatch<ActionBase>) => {
	const serviceProhibitionData = { ...initialServiceProhibitionData };

	const prohibitionResult = await callGetServiceProhibitionApi();
	if (prohibitionResult.status === HttpStatus.OK) {
		const successData = prohibitionResult.data as GetServiceProhibitionResData;
		serviceProhibitionData.use_prohibited_service = successData.use_prohibited_service;
	}

	const action = {
		action: SaveActionName,
		serviceProhibitionData,
	} as SaveAction;

	dispatch(action);
};

// Reducer
const saveReducer = (state: Store, action: ActionBase): Store => {
	const thisAction = action as SaveAction;
	const newState: Store = copyObject(state);
	newState.serviceProhibitionData = thisAction.serviceProhibitionData;
	return newState;
};

////////////////////////////////////////////////////////////////////////////////
// Reduce functions finder
////////////////////////////////////////////////////////////////////////////////
export const ServiceProhibitionReduceFunction = (state: Store, action: ActionBase): Store => {
	switch (action.action) {
		case SaveActionName:
			return saveReducer(state, action);
	}
	return null;
};
